import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ClosingImportRow, ClosingImportState } from './closing-import-banner.types';

/**
 * The import of a freshly started closing, as a banner over the overview — a pure view (REV-22527).
 *
 * It replaced a modal the trustee had to sit in front of: the launch runs on the server anyway, so
 * the overview opens at once and this banner reports how far the import got. The closing's steps
 * unlock as soon as the accounting data is in; that lock is the host's, not this view's.
 */
@Component({
    selector: 'abcp-closing-import-banner',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './closing-import-banner.component.html',
    styleUrls: ['./closing-import-banner.component.scss'],
})
export class ClosingImportBannerComponent {
    @Input() state: ClosingImportState = 'running';

    /** The rows in render order: the accounting data, then the documents when SharePoint is used. */
    @Input() rows: readonly ClosingImportRow[] = [];

    /** The failed row's message, already translated. Shown only in the `failed` state. */
    @Input() failureMessage: string | null = null;

    /** Why «Erneut versuchen» was refused, already translated. Shown only in the `failed` state. */
    @Input() retryError: string | null = null;

    /** «Erneut versuchen» — runs the launch again; finished steps are not repeated. */
    @Output() retried = new EventEmitter<void>();

    public trackByKey(_index: number, row: ClosingImportRow): string {
        return row.key;
    }

    public onRetry(): void {
        this.retried.emit();
    }
}
